module.exports = __webpack_public_path__ + "static/media/14.Barf Gola Machine.214faeea.jpg";